import type { State } from 'shared/types/gallery/state'

export function resolveInitialSwatchId(tileEntity: State.TileEntity): string {
  return tileEntity.selectedColorSwatchDesignId || tileEntity.designId
}
